import { ChakraProvider, createSystem, defaultConfig } from '@chakra-ui/react';
import { ThemeProvider } from 'next-themes';

import { useAppConfig } from './app-config-provider';

const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        heading: { value: "'Lexend', system-ui, sans-serif" },
        body: { value: "'Lexend', system-ui, sans-serif" },
      },
    },
  },
});

interface ChakraProviderWithColorModeProps {
  children: React.ReactNode;
}

export function ChakraProviderWithColorMode({
  children,
}: ChakraProviderWithColorModeProps) {
  const { config } = useAppConfig();
  const colorMode = config.colorMode ?? 'light';

  return (
    <ChakraProvider value={system}>
      <ThemeProvider
        attribute="class"
        disableTransitionOnChange
        forcedTheme={colorMode}
      >
        {children}
      </ThemeProvider>
    </ChakraProvider>
  );
}
